import React from "react";
import { Redirect } from "react-router-dom";
import { isPathBlockedForFinanceReadOnly } from "../../utils/financeAccess";

const FinanceReadOnlyGuard = ({ location, children }) => {
  if (isPathBlockedForFinanceReadOnly(location?.pathname)) {
    return <Redirect to="/mis/expenses/3" />;
  }
  return children;
};

export default FinanceReadOnlyGuard;
